import { Sparkles } from 'lucide-react';

interface SimilarBadgeProps {
  /** Extra classes for spacing/positioning in the host layout. */
  className?: string;
}

/**
 * Small orange "Similar To Me" pill shown on another user's account when they
 * share enough tags to be a discover "similar" match. Mirrors FriendBadge but in
 * orange. Styling is inline so it renders reliably regardless of Tailwind JIT
 * class pickup (same reason as FriendBadge). Only render when the user is
 * actually similar — it is not gated internally.
 */
export function SimilarBadge({ className = '' }: SimilarBadgeProps) {
  return (
    <span
      className={`inline-flex items-center justify-center whitespace-nowrap ${className}`}
      style={{
        gap: '3px',
        fontSize: '9px',
        fontWeight: 500,
        lineHeight: 1,
        padding: '3px 7px',
        borderRadius: '9999px',
        background: 'rgba(243,156,18,0.16)',
        color: '#E67E22',
      }}
    >
      <Sparkles style={{ width: '9px', height: '9px', flexShrink: 0 }} />
      Similar To Me
    </span>
  );
}

export default SimilarBadge;
